import { differenceInMinutes } from 'date-fns';
import getNowDate from '@sdk/utils/getNowDate';
import getCurrentBreak from '@sdk/automatedBreaks/helpers/getCurrentBreak';
import getBreaksSummary from '@sdk/automatedBreaks/helpers/getBreaksSummary';
import getShiftOnBreakDescription from '@sdk/automatedBreaks/helpers/getShiftOnBreakDescription';
import getBreakMinutes from '@sdk/automatedBreaks/helpers/getBreakMinutes';
import getLatestTimesheetProjection from '@sdk/automatedBreaks/helpers/getLatestTimesheetProjection';
import { TimesheetProjection } from '@sdk/automatedBreaks/types/TimesheetProjection';
import { TimesheetEntry } from '@sdk/timesheets/types/TimesheetEntry';
import gettext from 'sling-sdk/src/lang/gettext';

type Props = {
  automatedBreaksFeatureFlag: boolean;
  automatedBreaksEnabled: boolean;
  shift: {
    timesheetEntries: TimesheetEntry[];
    timesheetProjections: TimesheetProjection[];
    dtstart: Date;
    dtend: Date;
    breakDuration: number;
  };
};

const getBreakDescription = ({
  automatedBreaksFeatureFlag,
  automatedBreaksEnabled,
  shift,
}: Props) => {
  if (automatedBreaksFeatureFlag && automatedBreaksEnabled && shift?.timesheetEntries?.length) {
    const { timesheetEntries } = shift;

    const { breakRecords } = getBreaksSummary(timesheetEntries, shift.dtstart, shift.dtend);
    const currentBreak = getCurrentBreak(breakRecords);

    if (currentBreak) {
      const { startTimestampLocal, settings } = currentBreak;
      const minutesOnBreak = differenceInMinutes(getNowDate(), startTimestampLocal);

      return getShiftOnBreakDescription(settings.duration, minutesOnBreak);
    }
  } else {
    const timesheetProjection = getLatestTimesheetProjection(shift.timesheetProjections);
    if (timesheetProjection) {
      const { breakDuration = 0 } = shift;
      const minutesOnBreak = getBreakMinutes(timesheetProjection);
      return getShiftOnBreakDescription(breakDuration, minutesOnBreak);
    }
  }

  return gettext('Your break is in progress.');
};

export default getBreakDescription;
